import { HttpMethod } from '@previo/core'
import { APIPaths } from '~/http/APIPaths'
import Http from '~/http/Http'
import type { VATClassifications } from '~/http/invoicing/VATClassifications/types'

export class VATClassificationsAPI extends Http {
  getVATClassifications = (): Promise<VATClassifications> => {
    return this.callAuthWithPropertyAPI<null, VATClassifications>(
      HttpMethod.GET,
      {
        path: APIPaths.INVOICING_VAT_CLASSIFICATIONS,
      },
      null,
    )
  }
}
